// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  margin-top: 70px;
  padding: 20px;
}

.profile-card {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;

}
.card-headerHeadingTag{
  color: #000000;
  font-weight: 600;
  text-shadow: 1px 1.2px #c0baba;
}
.card {
  padding: 20px;
  border-radius: 12px;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  background-color: white;
}

.card-body {
  width: 500px;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(255, 0, 0, 0.2);
}

.form-control {
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 15px;
}

.form-body {
  width: 100%;
}

.form-group {
  width: 100%;
}

.profileCapital {
  background: linear-gradient(251deg, #cbec47, #b01fe6, #ff0000, #ffee00, #00ffff);
  background-size: 300% 300%;
  animation: gradient-animation 5s ease infinite;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  text-align: center;
  margin: 0 auto 20px;
  color: white;
  display: block;
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.invalid-feedback {
  display: block;
}

.accordion {
  margin-top: 15px;
}

/* Media Queries for Responsive Design */

/* iPhone and smaller devices */
@media (max-width: 375px) {
  .profile-card {
    padding: 10px;
  }
  .card {
    padding: 15px;
  }
  .card-body {
    width: 100%;
  }
  .profileCapital {
    height: 40px;
    width: 40px;
  }
}

/* iPad and small tablets */
@media (min-width: 376px) and (max-width: 768px) {
  .profile-card {
    padding: 15px;
  }
  .card {
    padding: 15px;
  }
  .card-body {
    width: 100%;
  }
  .profileCapital {
    height: 45px;
    width: 45px;
  }
}

/* Tablets and larger devices */
@media (min-width: 769px) and (max-width: 1024px) {
  .profile-card {
    padding: 20px;
  }
  .card {
    padding: 20px;
  }
  .card-body {
    width: 100%;
  }
  .profileCapital {
    height: 50px;
    width: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Profile/Profile.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;;AAEhB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mEAAmE;EACnE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gFAAgF;EAChF,0BAA0B;EAC1B,8CAA8C;EAC9C,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wCAAwC;;AAExC,+BAA+B;AAC/B;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".profile-container {\r\n  margin-top: 70px;\r\n  padding: 20px;\r\n}\r\n\r\n.profile-card {\r\n  width: 100%;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n\r\n}\r\n.card-headerHeadingTag{\r\n  color: #000000;\r\n  font-weight: 600;\r\n  text-shadow: 1px 1.2px #c0baba;\r\n}\r\n.card {\r\n  padding: 20px;\r\n  border-radius: 12px;\r\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\r\n  background-color: white;\r\n}\r\n\r\n.card-body {\r\n  width: 500px;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 8px 20px rgba(255, 0, 0, 0.2);\r\n}\r\n\r\n.form-control {\r\n  width: 100% !important;\r\n  max-width: 100%;\r\n  box-sizing: border-box;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.form-body {\r\n  width: 100%;\r\n}\r\n\r\n.form-group {\r\n  width: 100%;\r\n}\r\n\r\n.profileCapital {\r\n  background: linear-gradient(251deg, #cbec47, #b01fe6, #ff0000, #ffee00, #00ffff);\r\n  background-size: 300% 300%;\r\n  animation: gradient-animation 5s ease infinite;\r\n  height: 50px;\r\n  width: 50px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  margin: 0 auto 20px;\r\n  color: white;\r\n  display: block;\r\n}\r\n\r\n@keyframes gradient-animation {\r\n  0% {\r\n    background-position: 0% 50%;\r\n  }\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n.invalid-feedback {\r\n  display: block;\r\n}\r\n\r\n.accordion {\r\n  margin-top: 15px;\r\n}\r\n\r\n/* Media Queries for Responsive Design */\r\n\r\n/* iPhone and smaller devices */\r\n@media (max-width: 375px) {\r\n  .profile-card {\r\n    padding: 10px;\r\n  }\r\n  .card {\r\n    padding: 15px;\r\n  }\r\n  .card-body {\r\n    width: 100%;\r\n  }\r\n  .profileCapital {\r\n    height: 40px;\r\n    width: 40px;\r\n  }\r\n}\r\n\r\n/* iPad and small tablets */\r\n@media (min-width: 376px) and (max-width: 768px) {\r\n  .profile-card {\r\n    padding: 15px;\r\n  }\r\n  .card {\r\n    padding: 15px;\r\n  }\r\n  .card-body {\r\n    width: 100%;\r\n  }\r\n  .profileCapital {\r\n    height: 45px;\r\n    width: 45px;\r\n  }\r\n}\r\n\r\n/* Tablets and larger devices */\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .profile-card {\r\n    padding: 20px;\r\n  }\r\n  .card {\r\n    padding: 20px;\r\n  }\r\n  .card-body {\r\n    width: 100%;\r\n  }\r\n  .profileCapital {\r\n    height: 50px;\r\n    width: 50px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
